import { baseActions, baseMutations } from '../base'
import { formatDate } from '@/helpers/dateHelper'
import i18n from '@/i18n/i18n'

const initialState = () => {
  return {
    module: 'typesubscriptions',
    model: 'typesubscription',
    loading: false,
    selected: {
      active: false,
      name: [],
      specifications: [],
      typePayment: [],
    },
    list: [],
    selectList: [],
    pagination: {
      hasMore: false,
      page: 1,
      rowsPerPage: 0,
      totalItems: 0,
    },
    filters: {},
    type: ['singlePayment', 'monthly', 'yearly', 'ads'],
    typePayment: [],
    availableMatches: [
      'entity',
      'team',
      'league',
      'tournament',
      'match',
      'national',
      'territorial',
      'notlive',
    ],
  }
}

const state = initialState()

const getters = {
  paymentsTypes(state) {
    return state.type.map((item) => ({
      value: item,
      text: i18n.t(
        `fields.typeSubscriptions.typesPayment.${item.split('-')[0]}`
      ),
    }))
  },
  availableMatches(state) {
    return state.availableMatches.map((item) => ({
      value: item,
      text: i18n.t(`fields.typeSubscriptions.available.${item}`),
    }))
  },
  formatedList(state) {
    return state.list.map((item) => ({
      ...item,
      availableMatches: item.availableMatches.map((element) =>
        i18n.t(`fields.typeSubscriptions.available.${element}`)
      ),
      createdAt: formatDate(item.createdAt, true),
      createdBy: item.createdBy
        ? item.createdBy.name + ' ' + item.createdBy.lastname1
        : '-',
    }))
  },
}

const actions = {
  ...baseActions,
}

const mutations = {
  ...baseMutations,
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
  },
  setList(state, payload) {
    state.list = []
    if (Array.isArray(payload)) {
      payload.forEach((item) => state.list.push(item))
    }
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
